import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-270f281a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-list-container d-flex align-items-start justify-content-start gap-2 px-3 py-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus" }, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Add another list ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_kanban_task_list = _resolveComponent("kanban-task-list")!
  const _component_action_button = _resolveComponent("action-button")!
  const _component_kanban_add_form = _resolveComponent("kanban-add-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentBoard.lists, (list, index) => {
      return (_openBlock(), _createBlock(_component_kanban_task_list, {
        key: index,
        list: list
      }, null, 8, ["list"]))
    }), 128)),
    _createElementVNode("div", {
      class: _normalizeClass(["task-list-container__form p-1 rounded-1", { bg: _ctx.showAddForm }])
    }, [
      (!_ctx.showAddForm)
        ? (_openBlock(), _createBlock(_component_action_button, {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAddForm = true)),
            class: "task-list-container__form__btn p-0 text-white w-100 bg-transparent justify-content-start"
          }, {
            prefix: _withCtx(() => [
              _hoisted_2
            ]),
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_kanban_add_form, {
            key: 1,
            "input-type": 'input',
            "button-text": 'Add list',
            "show-sub-menu": false,
            onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAddForm = false)),
            onSubmit: _ctx.handleCreateList
          }, null, 8, ["onSubmit"]))
    ], 2)
  ]))
}